import type { API } from 'api/config/types';
import type { TimesAPI } from 'chessboard/api/times/config/types';
import { createGetTimes } from 'chessboard/api/times/model/get-times';
import { createSetManyTimes } from 'chessboard/api/times/model/set-many-times';
import { createSetTimes } from 'chessboard/api/times/model/set-times';

/**
 * Create the times API.
 *
 * This API is responsible for handling time (move time taken) values. It sets single or multiple
 * time values on move nodes and creates timestamps for the move list.
 */
export function createTimesAPI(context: API.Context): TimesAPI {
  return {
    get: createGetTimes(context),
    set: createSetTimes(context),
    setMany: createSetManyTimes(context),
  };
}
